if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      var urlParamsOnPack = new URLSearchParams(window.location.search);
      if(urlParamsOnPack.get('view') === 'pack') {
        formProductId = null;
      }
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';
      const packProducts = document.querySelector('.packs-bar__products');
      if(packProducts) {
        if(!packProducts.classList.contains('isHidden')) {
          openOrCloseItemPack();
        }
      }
      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      let item = opener.closest('.grid__item') || opener.closest('li');
      let dataSwatch = item.querySelector('.swatch-active').getAttribute('data-swatch');

      opener.setAttribute('aria-disabled', true);

      let overlay = document.getElementById('overlay');
      overlay.style.display = 'block';
      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          // this.PackBarOverlay();
          optionEvent();
          OpacityOption();
          wishlistLoad();
          renderSwatchProduct();
          if(this.querySelector('label[data-swatch="'+dataSwatch+'"]')) {
            if(!this.querySelector('label[data-swatch="'+dataSwatch+'"]').classList.contains("swatch-active")) {
              this.querySelector('label[data-swatch="'+dataSwatch+'"]').click();
            }
          }
          addEventAddToCart();
          getVariantOption();
          quickViewAddToPack(opener);
          // this.changeHeightMedia();
          renderSizeProduct();
          var appendChild = this.modalContent.querySelector('.size-guild-modal-container');
          appendChild.classList.remove('!tw-hidden');
          this.modalContent.querySelector('.size-guide-button--trigger');
          overlay.style.display = 'none';
          const changeText = document.querySelector(".product-form__buttons .product-form__submit span");
          changeText.textContent = "Añadir Pack";
          const packBar = document.querySelector('.packs-bar');
          var packBarHeight = packBar.offsetHeight;
          document.documentElement.style.setProperty('--packBarHeight', `${packBarHeight}px`);
        });
    }

    changeHeightMedia() {
      let quickAddModal = document.querySelector('quick-add-modal');
      if(quickAddModal) {
        let tabScrollInfor = quickAddModal.querySelector('#tab-scroll-infor-product');
        let productMedia = quickAddModal.querySelector('.product__media-wrapper');
        productMedia.style.height = ((window.innerWidth / 100 * 110) - tabScrollInfor.offsetHeight) + 'px';
      }
      addEventListener('resize', function () {
        let quickAddModal = document.querySelector('quick-add-modal');
        if(quickAddModal) {
          let tabScrollInfor = quickAddModal.querySelector('#tab-scroll-infor-product');
          let productMedia = quickAddModal.querySelector('.product__media-wrapper');
          productMedia.style.height = ((window.innerWidth / 100 * 110) - tabScrollInfor.offsetHeight) + 'px';
        }
      })
    }
    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);

      });
    }

    // PackBarOverlay(){
    //   if (window.innerWidth < 990) {
    //     const modalSize = this.modalContent.querySelector('.button-popup-size');
    //     modalSize.onclick = function() {
    //       packBar.style.display = "none";
    //     }
    //     const modalCloseSize = this.modalContent.querySelector('.close-popup-size');
    //     modalCloseSize.onclick = function() {
    //       packBar.style.display = "";
    //     }
    //     const optionSizeChoose = this.modalContent.querySelectorAll('.option-size-choose');
    //     optionSizeChoose.forEach(function(option) {
    //         if (!option.classList.contains('disabled')) {
    //             option.addEventListener('click', function() {
    //                 packBar.style.display = "";
    //               });
    //         }
    //     });
    //   }
    // }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());


      const recommendations = this.productElement.querySelectorAll('product-recommendations');
      if (recommendations) recommendations.forEach(recommendation => recommendation.remove());
      
      const reviewsection = this.productElement.querySelector('#review-product');
      if (reviewsection) reviewsection.remove();

      const yopto = this.productElement.querySelector('.section-yopto-instagram');
      if (yopto) yopto.remove();
      
      const productlabel = this.productElement.querySelector('.product__label');
      if (productlabel) productlabel.remove();
       
      const averagereview = this.productElement.querySelector('.product_average_review');
      if (averagereview) averagereview.remove();

      const sharebutton = this.productElement.querySelector('.share-button');
      if (sharebutton) sharebutton.remove();

      const overlayspinners = this.productElement.querySelectorAll('product-recommendations');
      if (overlayspinners) overlayspinners.forEach(overlayspinner => overlayspinner.remove());

      const loader = this.productElement.querySelector('#loader-you-may-so-to-like');
      if (loader) loader.remove();

      const Actionwishlist = this.productElement.querySelector('.action--wishlist');
      if (Actionwishlist) Actionwishlist.remove();
      
      const AccordionItems = this.productElement.querySelectorAll('.accordion__item');
      if (AccordionItems) AccordionItems.forEach(AccordionItem => AccordionItem.remove());

      const FooterSection = this.productElement.querySelector('.section-product-footer');
      if (FooterSection) FooterSection.remove();

      const preorderContain = this.productElement.querySelector('.preorder-tag-contain');
      if (preorderContain) preorderContain.remove();

      const lastImage = this.productElement.querySelector('.last--product__media-item');
      if (lastImage) lastImage.remove();

    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}
